import pkg from '../package.json';

import { MDHUB_CONTAINER_ID } from './services/constants';

/*
 * Altera os estilos da div onde os iframes do MdHub são inseridos
 */
const changeMdHubContainerStyle = (height: string): void => {
  const containers = ['root', MDHUB_CONTAINER_ID];

  containers.forEach((id) => {
    const container = document.getElementById(id);

    if (container) container.style.height = id === 'root' ? `calc(100% - ${height})` : height;
  });
};

MdHub.init({
  apiKey: 'nova',
  name: pkg.name,
  container: MDHUB_CONTAINER_ID,
  noDefaultHeight: true,
  modules: ['platform.notification', 'platform.onboarding-modal', 'plataforma.sdk'],
  styles: {
    position: 'static',
  },
});

MdHub.event.add('core:moduleHide', (module) => {
  if (module.moduleName === 'platform.notification') {
    changeMdHubContainerStyle('0px');
  }
});

MdHub.event.add('core:moduleShow', (module) => {
  if (module.moduleName === 'platform.notification') {
    changeMdHubContainerStyle('48px');
  }
});

MdHub.event.add('core:showLgpdNotification', () => {
  MdHub.event.trigger('core:showNotification', 'dispenser');
});

MdHub.optionsCustom.global.fullscreen = true;
